import { Role } from "protos/robot_syncer/plant_profile";
import { SvgIcon, type SvgIconProps } from "@mui/material";
import BeneficialRoleIcon from "portal/images/icons/plant_role_beneficial.svg?react";
import CropRoleIcon from "portal/images/icons/plant_role_crop.svg?react";
import DisregardRoleIcon from "portal/images/icons/plant_role_disregard.svg?react";
import React, { FC } from "react";
import WeedRoleIcon from "portal/images/icons/plant_role_weed.svg?react";

type PlantProfileRoleIconProps = {
  role: Role;
} & Omit<SvgIconProps, "component" | "children" | "role">;

const roleIcons: Partial<Record<Role, typeof CropRoleIcon>> = {
  [Role.CROP]: CropRoleIcon,
  [Role.BENEFICIAL]: BeneficialRoleIcon,
  [Role.DISREGARD]: DisregardRoleIcon,
  [Role.WEED]: WeedRoleIcon,
};

export const PlantProfileRoleIcon: FC<PlantProfileRoleIconProps> = ({
  role,
  fontSize = "inherit",
  ...props
}) => {
  const Icon = roleIcons[role];
  if (!Icon) {
    return;
  }
  return (
    <SvgIcon
      component={Icon}
      inheritViewBox
      fontSize={fontSize}
      aria-hidden
      {...props}
    />
  );
};
